export default "__VITE_ASSET__DFsGReEJ__"